module.exports = __webpack_public_path__ + "static/media/nutrition-badge.07754d23.svg";